// 彈窗開啟狀態閘門 — 供全域鍵盤操作（空白鍵 SPIN/快停）在任一彈窗開啟時抑制。
// 對照 Unity：彈窗以全螢幕 Mask 攔截 raycast，SPIN 鈕在彈窗下自然收不到輸入；
// 本移植的空白鍵走 window keydown（不經過 PixiJS 事件樹），需以此閘門等價抑制。

const openModals = new Set<object>()

/** 彈窗於 show()/hide() 時回報自身開關狀態。 */
export function reportModalOpen(owner: object, open: boolean): void {
  if (open) openModals.add(owner)
  else openModals.delete(owner)
}

/** 是否有任一彈窗開啟中。 */
export function isAnyModalOpen(): boolean {
  return openModals.size > 0
}
